import { XCircle } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/business-closing.jpg";

const BusinessClosing = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Business Entity Dissolution Services</h2>
          <p className="text-lg text-muted-foreground">
            Proper dissolution and winding up of Texas business entities. We handle LLC and corporation closures, asset distribution, final tax returns, and state filings to avoid ongoing liability and compliance issues.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Closing of Business Entities" subtitle="Properly Dissolve Your Business" icon={<XCircle className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default BusinessClosing;